import initModel from "./Model";
import { MSGS_UPLOAD, uploadUpdate } from './updates/UploadUpdate';

const MSGS = {
    LOGOUT: 'LOGOUT',
    SHOW_TERMS: 'SHOW_TERMS',
    INPUT_TERMS: 'INPUT_TERMS',
    RAPPORTID_INPUT: 'RAPPORTID_INPUT',
    KOMMUNE_NO: 'KOMMUNE_NO',
    KOMMUNE_NO_SELECT: 'KOMMUNE_NO_SELECT',
    ANY_TEXT: 'ANY_TEXT',
    DGU: 'DGU',
    KEYWORD: 'KEYWORD',
    SEARCH: 'SEARCH',
    HTTP_SUCCESS: 'HTTP_SUCCESS',
    DETAIL_HTTP_SUCCESS: 'DETAIL_HTTP_SUCCESS',
    LOGIN_HTTP_SUCCESS: 'LOGIN_HTTP_SUCCESS',
    HTTP_ERROR: 'HTTP_ERROR',
    SEARCH_FORM_SUBMIT: 'SEARCH_FORM_SUBMIT',
    SHOW_FRONT_PAGE: 'SHOW_FRONT_PAGE',
    SHOW_SEARCH_FORM: 'SHOW_SEARCH_FORM',
    SHOW_UPLOAD_FORM: 'SHOW_UPLOAD_FORM',
    SHOW_DETAIL_FORM: 'SHOW_DETAIL_FORM',
    LOAD_LINKS_DETAIL: 'LOAD_LINKS_DETAIL',
    LOAD_LINK_DETAIL_HTTP_SUCCESS: 'LOAD_LINK_DETAIL_HTTP_SUCCESS',
    HTTP_BOREHOLE_ERROR: 'HTTP_BOREHOLE_ERROR',
    PIN_CODE_INPUT: 'PIN_CODE_INPUT',
    EMAIL_INPUT: 'EMAIL_INPUT',
    EMAIL_FOR_PIN_INPUT: 'EMAIL_FOR_PIN_INPUT',
    LOGIN: 'LOGIN',
    REQUEST_PIN: 'REQUEST_PIN',
    REQUEST_PIN_SENT_HTTP_SUCCESS: 'REQUEST_PIN_SENT_HTTP_SUCCESS',
    HTTP_REQUEST_PIN_ERROR: 'HTTP_REQUEST_PIN_ERROR',
    SHOW_ORDER_PIN: 'SHOW_ORDER_PIN',
    SHOW_LOGIN: 'SHOW_LOGIN',
    HTTP_LOGIN_ERROR: 'HTTP_LOGIN_ERROR',
    SHOW_PREVIOUS_SEARCH_FORM: 'SHOW_PREVIOUS_SEARCH_FORM',
    SHOW_NEXT_SEARCH_FORM: 'SHOW_NEXT_SEARCH_FORM',
    LOAD_KEYWORDS_HTTP_SUCCESS: 'LOAD_KEYWORDS_HTTP_SUCCESS',
    DOWNLOAD_FILE: 'DOWNLOAD_FILE',
    DOWNLOAD_HTTP_SUCCESS: 'DOWNLOAD_HTTP_SUCCESS',
    SHOW_MODAL: 'SHOW_MODAL',
    DELETE_REPORT: 'DELETE_REPORT',
    DELETE_REPORT_HTTP_SUCCESS: 'DELETE_REPORT_HTTP_SUCCESS',
    EDIT_REPORT: 'EDIT_REPORT',
    CLEAR_STATUS_BANNER: 'CLEAR_STATUS_BANNER',
    BACK: 'BACK',
    ARE_YOU_SURE_DELETE_REPORT: 'ARE_YOU_SURE_DELETE_REPORT',
    CANCEL_DELETE_REPORT: 'CANCEL_DELETE_REPORT'
};
export const cancelDeleteMsg = {
    type: MSGS.CANCEL_DELETE_REPORT,
}
export const deleteAreYouSureMsg = {
    type: MSGS.ARE_YOU_SURE_DELETE_REPORT,
}
export const backMsg = {
   type: MSGS.BACK,
}
export const termsInputMsg = {
   type: MSGS.INPUT_TERMS,
}
export const showTermsMsg = {
    type: MSGS.SHOW_TERMS,
}
export const clearDeleteSuccessBannerMsg = {
    type: MSGS.CLEAR_STATUS_BANNER,
}
const deleteReportHttpSuccessMsg = ((response) => ({
    type: MSGS.DELETE_REPORT_HTTP_SUCCESS,
    response,
}));
// const editReportHttpSuccessMsg  = ((response) => ({
//     type: MSGS.EDIT_REPORT_HTTP_SUCCESS,
//     response,
// }));
export const deleteReportMsg = {
    type: MSGS.DELETE_REPORT
}
export const editReportMsg = {
    type: MSGS.EDIT_REPORT
}

export function downloadFileMsg(fileId, fileName) {
    return {
        type: MSGS.DOWNLOAD_FILE,
        fileId,
        fileName
    };
}

export function emailForPinInputMsg(email) {
    return {
        type: MSGS.EMAIL_FOR_PIN_INPUT,
        email,
    };
}
export function emailInputMsg(email) {
    return {
        type: MSGS.EMAIL_INPUT,
        email,
    };
}
export function pinCodeInputMsg(pinCode) {
    return {
        type: MSGS.PIN_CODE_INPUT,
        pinCode,
    };
}
export function rapportIdInputMsg(rapportId) {
    return {
        type: MSGS.RAPPORTID_INPUT,
        rapportId,
    };
}
export function kommuneNoInputMsg(kommuneno) {
    return {
        type: MSGS.KOMMUNE_NO,
        kommuneno,
    };
}
export function kommuneNoSelectInputMsg(kommunenoSelect) {
   return {
       type: MSGS.KOMMUNE_NO_SELECT,
       kommunenoSelect,
   };
}
export function anyTextInputMsg(anyText) {
    return {
        type: MSGS.ANY_TEXT,
        anyText,
    };
}
export function dguNrInputMsg(dgu) {
    return {
        type: MSGS.DGU,
        dgu,
    };
}
export function keywordSelectMsg(selectedKeyword) {
    return {
        type: MSGS.KEYWORD,
        selectedKeyword,
    };
}
export const showLoginMsg = {
    type: MSGS.SHOW_LOGIN,
    state: 'login'
}
export const showOrderPinMsg = {
    type: MSGS.SHOW_ORDER_PIN,
    state: 'orderPin'
}
export const loginMsg = {
    type: MSGS.LOGIN,
}
function httpLoginErrorMsg(error) {
    return {
        type: MSGS.HTTP_LOGIN_ERROR,
        error,
    };
}
export const requestPinMsg = {
    type: MSGS.REQUEST_PIN,
}
export const searchMsg = {
    type: MSGS.SEARCH_FORM_SUBMIT,
};
/*export const uploadMsg = {
    type: MSGS.UPLOAD_FORM_SUBMIT,
};*/
export const showSearchMsg = {
    type: MSGS.SHOW_SEARCH_FORM,
    state: 'search'
};
//export const loadKeywordsMsg = {
//    type: MSGS.LOAD_KEYWORDS
//};

export function showPreviousSearchMsg(offset) {
    return {
        type: MSGS.SHOW_PREVIOUS_SEARCH_FORM,
        offset: offset
    }
}
export function showNextSearchMsg(offset) {
    return {
        type: MSGS.SHOW_NEXT_SEARCH_FORM,
        offset: offset
    }
}
export function showDetailMsg(rapportId) {
    return {
        type: MSGS.SHOW_DETAIL_FORM,
        state: 'detail',
        selectedRapportId: rapportId
    }
}

const linkDetailHttpSuccessMsg = ((response) => ({
    type: MSGS.LOAD_LINK_DETAIL_HTTP_SUCCESS,
    response,
}));
export const loadLinkDetailMsg = {
    type: MSGS.LOAD_LINKS_DETAIL,
};

export const showUploadMsg = {
    type: MSGS.SHOW_UPLOAD_FORM,
    state: 'upload'
};

const keywordsHttpSuccessMsg = ((response) => ({
    type: MSGS.LOAD_KEYWORDS_HTTP_SUCCESS,
    response,
}));
const searchHttpSuccessMsg = ((response) => ({
    type: MSGS.HTTP_SUCCESS,
    response,
}));
export const detailHttpSuccessMsg = ((response) => ({
    type: MSGS.DETAIL_HTTP_SUCCESS,
    response,
}));
const loginHttpSuccessMsg = ((response) => ({
    type: MSGS.LOGIN_HTTP_SUCCESS,
    response,
}));
const pinRequestSentHttpSuccessMsg = ((response) => ({
    type: MSGS.REQUEST_PIN_SENT_HTTP_SUCCESS,
    response,
}));
const downloadHttpSuccessMsg = ((response) => ({
    type: MSGS.DOWNLOAD_HTTP_SUCCESS,
    response,
}));

function httpBoreholeErrorMsg(error) {
    return {
        type: MSGS.HTTP_BOREHOLE_ERROR,
        error,
    };
}
export function httpErrorMsg(error) {
    return {
        type: MSGS.HTTP_ERROR,
        error,
    };
}
function httpRequestPinErrorMsg(error) {
    return {
        type: MSGS.HTTP_REQUEST_PIN_ERROR,
        error,
    };
}

const mainUrl = `/grundvandsrapport/api/`;
const formularUrl = `/formular-api/api/`;

function loadKeywordsUrl() {
    return `${mainUrl}keywords`;
}
function rapportUrl(search) {
    let params = search.rapportid ? `rapportId=${encodeURI(search.rapportid)}` : '';
    params += search.kommuneno ? `&kommune=${encodeURI(search.kommuneno)}` : '';
    params += search.anytext ? `&fritekst=${encodeURI(search.anytext)}` : '';
    params += search.dgu ? `&dgu=${encodeURI(search.dgu)}` : '';
    params += search.selectedKeyword.length > 0 ? `&keyword=${encodeURI(search.selectedKeyword)}` : '';
    return `${mainUrl}search?` + params;
}

function deleteRapportUrl(selectedRapportId) {
    let params = selectedRapportId ? `rapportId=${encodeURI(selectedRapportId)}` : '';
    return `${mainUrl}deleteReport?` + params;
}
// function editRapportUrl(selectedRapportId) {
//     let params = selectedRapportId ? `rapportId=${encodeURI(selectedRapportId)}` : '';
//     return `${mainUrl}updateReport?` + params;
// }
export function rapportDetailUrl(selectedRapportId) {
    let params = selectedRapportId ? `rapportId=${encodeURI(selectedRapportId)}` : '';
    return `${mainUrl}details?` + params;
}
function loadLinksDetailUrl(links) {
    const linkList = links.map(l => l.link);
    return 'https://data.geus.dk/gw-jupiter/borehole?limit=50&offset=0&boreholeid=in.(' + encodeURI(linkList) + ')';
}
function loginUrl(email, pinCode, formularType) {
    let params = `email=${encodeURI(email)}&pin=${encodeURI(pinCode)}&formularType=${encodeURI(formularType)}&path=${encodeURI('/grundvandsrapport/api')}`;
    return `${formularUrl}login?` + params;
}
function requestPinUrl(email, formularType) {
    let params = `email=${encodeURI(email)}&formularType=${encodeURI(formularType)}`;
    return `${formularUrl}requestPin?` + params;
}
function downloadFileUrl(filId) {
    let params = `fileId=${encodeURI(filId)}`;
    return `${mainUrl}download/?` + params;
}
export const showModalMsg = {
    type: MSGS.SHOW_MODAL
};
export const showFrontPageMsg = {
    type: MSGS.SHOW_FRONT_PAGE,
    state: 'frontPage'
};
export const logoutMsg = {
    type: MSGS.LOGOUT,
}
function update(msg, model) {
    if (msg.type in MSGS) {

        switch (msg.type) {
            case MSGS.BACK: {
                return model;
            }
            case MSGS.SHOW_TERMS: {
                const terms = !model.terms;
                return { ...model, terms: terms }
            }
            case MSGS.INPUT_TERMS: {
                const termsAccepted = !model.terms_accepted;
                return { ...model, terms_accepted: termsAccepted }
            }
            case MSGS.SHOW_MODAL: {
                return { ...model, modal: true }
            }
            /* ------- INITIALIZE ------*/
            case MSGS.LOAD_KEYWORDS_HTTP_SUCCESS: {
                const { response } = msg;

                const resultKeywords = [];
                const keywordsResponse = response.data.keywords;
                for (let i in keywordsResponse)
                    resultKeywords.push( { "kode": keywordsResponse[i], "text": i } );
                if (resultKeywords.length === 0) resultKeywords.push( { "kode":'Fejl: Ingen nøgleord fundet.', "text": 'Fejl: Ingen nøgleord fundet.' } );

                const resultMethods = [];
                const methodsResponse = response.data.methods;
                for (let i in methodsResponse)
                    resultMethods.push( { "kode": methodsResponse[i], "text": i } );

                const resultCentres = [];
                const centresResponse = response.data.centers;
                for (let i in centresResponse)
                    resultCentres.push( { "kode": centresResponse[i], "text": i } );

                const resultLaws = [ { "kode":'', "text":'' } ];
                const lawsResponse = response.data.laws;
                for (let i in lawsResponse)
                    resultLaws.push( { "kode": lawsResponse[i], "text": i } );

                const resultPurpose = [ { "kode":'', "text":'' } ];
                const purposeResponse = response.data.purpose;
                for (let i in purposeResponse)
                    resultPurpose.push( { "kode": purposeResponse[i], "text": i } );

                const resultMunicipality = [ { "kode":'', "nummer":'', "text":'' } ];
                const municipalityResponse = response.data.municipality;
                for (let i in municipalityResponse)
                    resultMunicipality.push( { "kode": municipalityResponse[i].split("_")[0], "nummer": municipalityResponse[i].split("_")[1], "text": i } );

                return {
                    ...model,
                    constLists : {
                        searchKeywords: resultKeywords,
                        searchMethods: resultMethods,
                        searchCentres: resultCentres,
                        searchLaws: resultLaws,
                        searchPurpose: resultPurpose,
                        searchMunicipality: resultMunicipality
                    },
                    request: { },
                    call: false,
                    post: false,
                    error: '',
                    successMsg: '', errorMsg: ''
                };
            }

            /* --------- LOGIN ---------*/
            case MSGS.EMAIL_INPUT: {
                return { ...model, login: { ...model.login, email: msg.email } };
            }
            case MSGS.PIN_CODE_INPUT: {
                return { ...model, login: { ...model.login, pinCode: msg.pinCode } };
            }
            case MSGS.LOGIN: {
                return { ...model,
                    request: {
                        withCredentials: true,
                        url: loginUrl(model.login.email, model.login.pinCode, 'GRUNDVANDSRAPPORT')
                    },
                    call: true,
                    login: {
                        ...model.login, error: '', emailSent: false
                    },
                    successMsg: loginHttpSuccessMsg,
                    errorMsg: httpLoginErrorMsg,
                };
            }
            case MSGS.LOGIN_HTTP_SUCCESS: {
                return {
                    ...model,
                    state: 'search',
                    post: false,
                    login: { ...model.login, loggedin: true, pinCode: '' },
                    error: '',
                    request: {
                        url: loadKeywordsUrl()
                    },
                    call: true,
                    successMsg: keywordsHttpSuccessMsg,
                    errorMsg: httpErrorMsg,
                };
            }
            case MSGS.HTTP_LOGIN_ERROR: {
                const { error } = msg;
                return { ...model, login: { ...model.login, loggedin: false, error: error.response.data }, state: 'login', success: '', request: {}, call: false, post: false,
                 successMsg: '', errorMsg: '', };
            }

            /* --------- REQUEST PIN ---------*/
            case MSGS.EMAIL_FOR_PIN_INPUT: {
                return { ...model, login: { ...model.login, emailForPin: msg.email } };
            }
            case MSGS.REQUEST_PIN: {
                return { ...model,
                    request: {
                        url: requestPinUrl(model.login.emailForPin, 'GRUNDVANDSRAPPORT')
                    },
                    call: true,
                    login: {
                        ...model.login, error: '', emailSent: false
                    },
                    successMsg: pinRequestSentHttpSuccessMsg,
                    errorMsg: httpRequestPinErrorMsg,
                };
            }
            case MSGS.HTTP_REQUEST_PIN_ERROR: {
                const { error } = msg;
                const errorMessage = error.response ? error.response.data : error.message;
                return { ...model, login: { ...model.login, error: errorMessage }, state: 'orderPin', success: '', request: { }, call: false, post: false,
                 successMsg: '', errorMsg: '', };
            }
            case MSGS.REQUEST_PIN_SENT_HTTP_SUCCESS: {
                return {
                    ...model,
                    request: { },
                    call: false,
                    post: false,
                    error: '',
                    login: { ...model.login, emailForPin: '', emailSent: true },
                    successMsg: '', errorMsg: '',
                };
            }

            /* --------- NAVIGATION ---------*/
            case MSGS.SHOW_FRONT_PAGE:
            case MSGS.SHOW_LOGIN:
            case MSGS.SHOW_ORDER_PIN:
                return {
                    ...initModel, noSearch: true, state: msg.state, login: { ...model.login, error: '' },
                        error: '', constLists: model.constLists
                };
            case MSGS.SHOW_SEARCH_FORM: {
                if (!model.constLists.searchKeywords.length) {
                    return {
                        ...initModel,
                        state: msg.state,
                        noSearch: true,
                        post: false,
                        login: { ...model.login },
                        error: '',
                        request: {
                            url: loadKeywordsUrl()
                        },
                        call: true,
                        successMsg: keywordsHttpSuccessMsg,
                        errorMsg: httpErrorMsg,
                    };
                }
                return {
                    ...initModel, noSearch: true, state: msg.state, login: { ...model.login, error: '' },
                        error: '', constLists: model.constLists
                };
            }
            case MSGS.SHOW_UPLOAD_FORM: {
                if (!model.constLists.searchKeywords.length) {
                    return {
                        ...model,
                        state: msg.state,
                        post: false,
                        error: '',
                        request: {
                            url: loadKeywordsUrl()
                        },
                        call: true,
                        successMsg: keywordsHttpSuccessMsg,
                        errorMsg: httpErrorMsg,
                    };
                }

                return { ...initModel, state: msg.state, constLists: model.constLists, login: { ...model.login, error: '' } };
            }

            /* --------- SEARCH ---------*/
            case MSGS.RAPPORTID_INPUT: {
                const { rapportId } = msg;
                return { ...model, rapportid: rapportId, success: '',error: '' };
            }
            case MSGS.KOMMUNE_NO: {
                const { kommuneno } = msg;
                return { ...model, kommuneno: kommuneno, kommunenoSelect: '', success: '',error: '' };
            }
            case MSGS.KOMMUNE_NO_SELECT: {
                const { kommunenoSelect } = msg;
                return { ...model, kommuneno: '', kommunenoSelect: kommunenoSelect, success: '',error: '' };
            }
            case MSGS.ANY_TEXT: {
                const { anyText } = msg;
                return { ...model, anytext: anyText, success: '',error: '' };
            }
            case MSGS.DGU: {
                const { dgu } = msg;
                return { ...model, dgu: dgu, success: '',error: '' };
            }
            case MSGS.KEYWORD: {
                const { selectedKeyword } = msg;
                return { ...model, selectedKeyword: selectedKeyword, success: '',error: '' };
            }
            case MSGS.SEARCH_FORM_SUBMIT: {
                const { rapportid, kommunenoSelect, anytext, dgu, selectedKeyword, url } = model;
                const search = {
                    url: url,
                    rapportid: rapportid,
                    kommuneno: kommunenoSelect,
                    anytext: anytext,
                    selectedKeyword: selectedKeyword,
                    dgu: dgu
                };
                return {
                    ...model,
                    request: {
                        url: rapportUrl(search),
                    },
                    offset: 0,
                    noSearch: false,
                    call: true,
                    successMsg: searchHttpSuccessMsg,
                    errorMsg: httpErrorMsg,
                };
            }
            case MSGS.HTTP_SUCCESS: {
                const { response } = msg;
                return {
                    ...model,
                    request: { },
                    call: false,
                    post: false,
                    success: 'SUCCESS',
                    queryResult: response.data,
                    error: '',
                    successMsg: '', errorMsg: '',
                };
            }
            case MSGS.HTTP_ERROR: {
                const { error } = msg;

                if (error.response && error.response.status === 401) {
                    return { ...initModel, error: 'Sessionen er udløbet. Log ind igen.' };
                }
                if (error.response.data) {
                    return { ...model, error: error.response.data, success: '', request: { }, call: false, post: false, download: '',successMsg: '', errorMsg: '',  };
                }
//                console.log('HTTTP Error:', error.message);
                return { ...model, error: error.message, success: '', request: { }, call: false, post: false, download: '',successMsg: '', errorMsg: '',  };
            }
            case MSGS.SHOW_NEXT_SEARCH_FORM: {
                const { offset } = msg;
                const nextOffset = offset + 25 > model.queryResult.length ? offset : offset + 25;
                return { ...model, offset: nextOffset };
            }
            case MSGS.SHOW_PREVIOUS_SEARCH_FORM: {
                const { offset } = msg;
                const nextOffset = offset - 25 < 0 ? 0 : offset - 25;
                return { ...model, offset: nextOffset };
            }
            /* --------- SHOW REPORT ---------*/
            case MSGS.DETAIL_HTTP_SUCCESS: {
                const { response } = msg;
                return {
                    ...model,
                    request: { },
                    call: false,
                    post: false,
                    detail: { ...model.detail, queryResult: response.data, linkError: '' },
                    successMsg: '',
                    errorMsg: '',
                    error: ''
                };
            }
            case MSGS.HTTP_BOREHOLE_ERROR: {
                const { error } = msg;
                console.log('error:', error);
                if (error.response.data) {
                    return { ...model, detail: { ...model.detail, linkError: error.response.data.message }, success: '', request: { }, call: false, post: false, download: '',successMsg: '', errorMsg: '',  };
                }

                return { ...model, detail: { ...model.detail, linkError: 'Ukendt fejl' }, success: '', request: { }, call: false, post: false, download: '',successMsg: '', errorMsg: '',  };
            }
            case MSGS.SHOW_DETAIL_FORM: {
                return { ...model, state: msg.state, detail: { ...model.detail, selectedRapportId: msg.selectedRapportId, loadReportId: '', loadLinks: true },
                    request: {
                        url: rapportDetailUrl(msg.selectedRapportId)
                    },
                    call: true,
                    successMsg: detailHttpSuccessMsg,
                    errorMsg: httpErrorMsg,
                };
            }
            case MSGS.LOAD_LINKS_DETAIL: {
                return { ...model,
                    detail: { ...model.detail, loadLinks: false },
                    request: {
                        url: loadLinksDetailUrl(model.detail.queryResult.links.filter(link => link.type === 'BORING'))
                    },
                    call: true,
                    successMsg: linkDetailHttpSuccessMsg,
                    errorMsg: httpBoreholeErrorMsg,
                };
            }
            case MSGS.LOAD_LINK_DETAIL_HTTP_SUCCESS: {
                const { response } = msg;
                const updateLinks = model.detail.queryResult.links.map(l => {
                    if (l.type === 'BORING' && response.data) {
                        const pretty = response.data.filter(pl => pl.boreholeid === parseInt(l.link));
                        if (pretty.length === 1)
                            l.prettyLink = pretty[0].boreholeno + ' (' + pretty[0].location + ')';
                    }

                    return l;
                });
                return {
                    ...model,
                    request: { },
                    call: false,
                    post: false,
                    detail: { ...model.detail, /* prettyLinks: response.data, */ queryResult: { ...model.detail.queryResult, links: updateLinks } },
                    successMsg: '',
                    errorMsg: '',
                    error: ''
                };
            }
            case MSGS.DOWNLOAD_FILE: {
                const { fileId, fileName } = msg;
                return {
                    ...model,
                    download: fileName,
                    post: false,
                    error: '',
                    request: {
                        url: downloadFileUrl(fileId),
                        responseType: 'blob'
                    },
                    call: true,
                    successMsg: downloadHttpSuccessMsg,
                    errorMsg: httpErrorMsg,
                };
            }
            case MSGS.DOWNLOAD_HTTP_SUCCESS: {
                return {
                    ...model,
                    download: '',
                    request: { },
                    call: false,
                    post: false,
                    error: '',
                    successMsg: '', errorMsg: '',
                };
            }
            case MSGS.ARE_YOU_SURE_DELETE_REPORT: {
                return {
                    ...model,
                    deleteForSure: true
                };
            }
            case MSGS.CANCEL_DELETE_REPORT: {
                return {
                    ...model,
                    deleteForSure: false
                };
            }
            case MSGS.DELETE_REPORT: {
                return {
                    ...model,
                    request: {
                        url: deleteRapportUrl(model.detail.selectedRapportId)
                    },
                    call: true,
                    successMsg: deleteReportHttpSuccessMsg,
                    errorMsg: httpErrorMsg,
                    deleteForSure: false
                };
            }
            case MSGS.DELETE_REPORT_HTTP_SUCCESS: {
                return {
                    ...model,
                    detail: { ...model.detail, deleted: true },
                    request: { },
                    call: false,
                    post: false,
                    error: '',
                    successMsg: '', errorMsg: '',
                };
            }

            case MSGS.EDIT_REPORT: {
                const details = model.detail.queryResult;
                const boringer = details.links.filter(l => l.type === "BORING").map(l => l.prettyLink);
                const boringId = details.links.filter(l => l.type === "BORING").map(l => l.link);
                const geoFysProjects = details.links.filter(l => l.type === "GEOFYSISK").map(l => l.link);
                const geoFysProjectIds = details.links.filter(l => l.type === "GEOFYSISK").map(l => l.id);
                const models = details.links.filter(l => l.type === "MODEL").map(l => l.link);
                const modelIds = details.links.filter(l => l.type === "MODEL").map(l => l.id);
                const municipality = model.constLists.searchMunicipality.filter(k => k.text === details.kommuneNavn).map(k => k.kode);
                const purpose = model.constLists.searchPurpose.filter(k => k.text === details.formaal).map(k => k.kode);
                const law = model.constLists.searchLaws.filter(k => k.text === details.lovgrundlag).map(k => k.kode);
                const fileNames = details.files.map(k => k.filNavn);
                const fileIds = details.files.map(k => k.id);
                const wkts = details.geoRefs.map((l, idx, geoRefs) => {
                        if (idx + 1 < geoRefs.length) return l.wktGeometry + '+';
                        else return l.wktGeometry;
                    });
                const wktIds = details.geoRefs.map(l => l.id);
                const selectedKeywordsArr = details.noegleord.split(',');
                const selectedKeywordsCodes = model.constLists.searchKeywords
                    .filter(item => selectedKeywordsArr.includes(item.text))
                    .map(item => item.kode);
                const selectedMethodsArr = details.metode.split(',');
                const selectedMethodsCodes = model.constLists.searchMethods
                    .filter(item => selectedMethodsArr.includes(item.text))
                    .map(item => item.kode);
                const selectedCentresArr = details.miljocenter.split(',');
                const selectedCentresCodes = model.constLists.searchCentres
                    .filter(item => selectedCentresArr.includes(item.text))
                    .map(item => item.kode);
                const publishDate = details.udgivelsesdato ? (details.udgivelsesdato.substring(6) + '-' + details.udgivelsesdato.substring(3,5) + '-' + details.udgivelsesdato.substring(0,2)) : '';
                return {
                    ...model,
                    state: 'edit',
                    upload: {
                        rapportId: details.rapportId, title: details.titel, pages: details.antalsider, isbn: details.isbn, author: details.forfattere,
                        shortTitle: details.korttitel, subTitle: details.undertitel1, publishDate: publishDate,
                        email: model.login.email, pin: model.login.pinCode,
                        files: {} , filesArr: [], fileNames: [], oldFiles: fileNames, oldFilesIds: fileIds,
                        addedDgu: boringer, addedDguFull: boringId,
                        addedModelLink: models, addedModelLinkIds: modelIds, addedGeoFysProject: geoFysProjects, addedGeoFysProjectIds : geoFysProjectIds,
                        wkt: wkts, wktIds: wktIds,
                        selectedKeyword: selectedKeywordsCodes, selectedMethod: selectedMethodsCodes, selectedCenter: selectedCentresCodes,
                        selectedLaws: law, selectedPurpose: purpose, selectedMunicipality: municipality,
                        selectArea: 'tabKeyword', drawType: 'Ingen', tab: 'metadata',
                        dguList: [], geoFysList: [],
                        success: '', error: '', errorModal: false
                    }
                };
            }
            case MSGS.CLEAR_STATUS_BANNER: {
                return { ...initModel, state: 'search', login: model.login, error: '', constLists: model.constLists };
            }
            case MSGS.LOGOUT: {
                document.cookie = "rdbUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/grundvandsrapport/api;";
                return { ...model, login:  { loggedin: false } };
            }
        }
    }
    if (msg.type in MSGS_UPLOAD) {
        return uploadUpdate(msg, model);
    }
    return model;
}
export default update;